// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1WzIR","error":"Textarea_error__3LoEB","readonly":"Textarea_readonly__2i2ZU","disabled":"Textarea_disabled__21lYl"};